/// <amd-module name="Artifacts/Pypi/commands/GetLink" />
import { getLinkCommandCreator } from "Artifacts/Root/protocols/Commands";

export const createGetLinkCommand = getLinkCommandCreator();
